import { render } from "./PromptView.vue?vue&type=template&id=b5f575c4&scoped=true&ts=true"
import script from "./PromptView.vue?vue&type=script&lang=ts"
export * from "./PromptView.vue?vue&type=script&lang=ts"

import "./PromptView.vue?vue&type=style&index=0&id=b5f575c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f575c4"]])

export default __exports__